// ✅ RM Return Verification - User B Module
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const RMReturnVerification = () => {
  const [returns, setReturns] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [rejectionReasons, setRejectionReasons] = useState({});

  const user = JSON.parse(localStorage.getItem("user"));
  const fetchReturns = async () => {
    try {
      const response = await axiosInstance.get("/api/rm-return");
      setReturns(response.data);
    } catch (error) {
      console.error("Error fetching RM returns:", error);
    }
  };

  useEffect(() => {
    fetchReturns();
  }, []);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  //   const handleImageUpload = async (e, rowId) => {
  //     const file = e.target.files[0];
  //     if (!file || !rowId) return;

  //     const formData = new FormData();
  //     formData.append("image", file);

  //     try {
  //       await axiosInstance.patch(`/api/rm-return/${rowId}/upload-image`, formData);
  //       alert("Image uploaded successfully");
  //       fetchReturns();
  //     } catch (err) {
  //       alert("Failed to upload image");
  //     }
  //   };

  // Srachinput For the rm-return
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [, setIsLoading] = useState(false);

  const handleSearch = async () => {
    if (!searchValue.trim()) return alert("Enter a LOT ID to search");

    try {
      setIsLoading(true);
      const response = await axiosInstance.get(
        `/api/rm-return-search/${searchValue}`
      );
      setSearchResults(response.data);
    } catch (error) {
      console.error("Search error:", error);
      alert("Failed to fetch data.");
    } finally {
      setIsLoading(false);
    }
  };

  // End of Srachinput For the rm-return

  const handleConfirmStatus = async (id) => {
    try {
      await axiosInstance.patch(`/api/rm-return/${id}/confirm-status`, {
        ConfirmedBy: user?.Name || "Supervisor",
      });
      showAlert("Status updated to Confirmed", "success");
      fetchReturns();
    } catch (err) {
      alert("Failed to update status");
    }
  };

  const handleRejectStatus = async (id) => {
    const reason = rejectionReasons[id]?.trim();
    if (!reason) {
      alert("Please enter a rejection reason.");
      return;
    }
    try {
      await axiosInstance.patch(`/api/rm-return/${id}/reject`, {
        RejectReason: reason,
        RejectedBy: user?.Name,
      });
      showAlert("Status updated to Rejected", "success");
      fetchReturns();
    } catch (err) {
      alert("Failed to reject RM return");
    }
  };

  const handleReasonChange = (id, value) => {
    setRejectionReasons((prev) => ({ ...prev, [id]: value }));
  };

  const handleViewImage = (imagePath) => {
    setSelectedImage(`${axiosInstance.defaults.baseURL}/uploads/${imagePath}`);
    setShowImageModal(true);
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 3000);
  };

  const columns = [
     { name: "Department", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Department}
      >
      {row.Department || "N/A"}
      </span>
    ), sortable: true },
  { name: "LOT ID",width:"190px", selector: (row) =>(
      <span 
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.LOT_ID}
      >
      { row.LOT_ID}
      </span>
    ), sortable: true },
    { name: "Quantity", selector: (row) => row.RM_Quantity, sortable: true },
    { name: "Damage QTY", selector: (row) => row.DamageQTY || "N/A", sortable: true },
    {
      name: "Status",
      selector: (row) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "6px",
            fontWeight: "bold",
            display: "inline-block",
            color:
              row.Status === "Confirmed"
                ? "#155724"
                : row.Status === "Rejected"
                ? "#721c24"
                : "#856404",
            backgroundColor:
              row.Status === "Confirmed"
                ? "#d4edda"
                : row.Status === "Rejected"
                ? "#f8d7da"
                : "#fff3cd",
          }}
        >
          {row.Status}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => new Date(row.CreatedAt).toLocaleString("en-GB"),
      sortable: true,
    },
      { name: "Remarks", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Remarks}
      >
      {row.Remarks || "N/A"}
      </span>
    ), sortable: true },
       { name: "Location", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Location}
      >
      {row.Location || "N/A"}
      </span>
    ), sortable: true },
    {
      name: "Image",
      cell: (row) =>
        row.ImagePath ? (
          <button
            className="btn btn-sm btn-outline-info"
            onClick={() => handleViewImage(row.ImagePath)}
          >
            View Image
          </button>
        ) : (
          <span className="text-muted">No Image</span>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Reason",
      width: "200px",
      cell: (row) => (
        <textarea
          className="form-control"
          rows="1"
          placeholder="Reason for rejection"
          value={
            rejectionReasons[row.ID] !== undefined
              ? rejectionReasons[row.ID]
              : row.RejectReason || ""
          }
          onChange={(e) => handleReasonChange(row.ID, e.target.value)}
          // onBlur={() => handleRejectStatus(row.ID)}
          disabled={row.Status === "Confirmed" || row.Status === "Rejected"}
          style={{ fontSize: "14px" }}
        />
      ),
    },
    // {
    //   name: "Actions",
    //   cell: (row) =>
    //     row.Status === "Confirmed" ? (
    //       <div className="approved-wrapper" title="Already Approved">
    //         <button
    //           className="btn btn-sm btn-success"
    //           disabled
    //           style={{ cursor: "not-allowed", opacity: 0.6 }}
    //         >
    //           Approved
    //         </button>
    //       </div>
    //     ) : (
    //       <button
    //         className="btn btn-sm btn-success"
    //         onClick={() => handleConfirmStatus(row.ID)}
    //       >
    //         Approve
    //       </button>
    //     )
    // }
    {
      name: "Actions",
      cell: (row) =>
        row.Status === "Confirmed" ? (
          <button
            className="btn btn-sm btn-success"
            disabled
            style={{ cursor: "not-allowed", opacity: 0.6 }}
          >
            Approved
          </button>
        ) : row.Status === "Rejected" ? (
          <button
            className="btn btn-sm btn-danger"
            disabled
            style={{ cursor: "not-allowed", opacity: 0.6 }}
          >
            Rejected
          </button>
        ) : (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => handleConfirmStatus(row.ID)}
            >
              ✅
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRejectStatus(row.ID)}
            >
              ❌
            </button>
          </div>
        ),
    },
  ];

  return (
    <div className="d-flex dashboard">
      <div
        className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}
      >
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
        <main
          className="main-container p-4"
          style={{ height: "-webkit-fill-available" }}
        >
          <h4 className="mb-4">RM Return Verification</h4>
          <div
            className="input-group input-group-sm mb-3"
            style={{ maxWidth: "400px" }}
          >
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Enter LOT ID"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <button className="btn btn-sm btn-primary" onClick={handleSearch}>
              Search
            </button>
          </div>

          <DataTable
            columns={columns}
            data={searchValue ? searchResults : returns}
            pagination
          />

          {/* <DataTable columns={columns} data={returns} pagination /> */}
        </main>
      </div>

      {/* View Image Modal */}
      {showImageModal && (
        <>
          {/* Bootstrap Backdrop */}
          <div className="modal-backdrop fade show"></div>

          {/* Bootstrap Modal */}
          <div className="modal show" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Returned RM Image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowImageModal(false)}
                  ></button>
                </div>
                <div className="modal-body text-center">
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt="Returned RM"
                      style={{ maxWidth: "100%", maxHeight: "500px" }}
                    />
                  ) : (
                    <p>No image available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RMReturnVerification;
